<div class=" body_container text-grey">
  <app-component-navigation></app-component-navigation>
  <div class="row h-97 w-100 ms-1">
    <div class="w-100 d-flex flex-column h-100 p-0">
      <div class="topPanel marginForLogs d-none">
        <h2 class="mainHeading">Monitor Deployment - </h2>
        <h4><span class="bi bi-layers"></span> {{ depName }}</h4>
        @if(activeLeftPanelIndex == 0) {
          <button type="button" *ngIf="this.isOnPremise"
                  class="actionBtn"
                  title="Power on all the nodes and runs custom scripts"
                  (click)="powerOnGracefully()"
                  triggers="hover" ngbTooltip="Power up">
            <span class="bi bi-plug">
            </span>
          </button>
          <button type="button" *ngIf="this.isOnPremise"
                  class="actionBtn"
                  title="Cancel all the active jobs, runs the custom scripts and power off all the nodes"
            (click)="powerOffGracefully()"
                  triggers="hover" ngbTooltip="Graceful power off"
                  >
            <span class="bi bi-power">
             
            </span>
          </button>
        }
        <button type="button" class="actionBtn" title="Refresh Details" (click)='refreshComponent()' triggers="hover" ngbTooltip="Refresh">
          <span class="bi bi-arrow-clockwise"></span>
         
        </button>
      </div>
      <div class="flex-grow-1 h-95">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>
